/// <reference path="services/kensoftapi.jsx" />
/**
 * Entry application component used to compose providers and render Routes.
 * */
import React from 'react';
import {
  Button,
  Container,
  Row,
  Col,
  Media,
  Card,
  CardImg,
  CardText,
  Form,
  FormGroup,
  Input,
  CardTitle,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
// Web Icon fonts
import Icofont from 'react-icofont';
// Web theme color root css
import './components/colors.css';
import Tdsheader from './components/Tdsheader';
import Tdsbanner from './components/Tdsbanner';
import Tdsinputgroup from './components/Tdsinputgroup';
import Tdsaboutslider from './components/Tdsaboutslider';
import Tdsfeedbackslider from './components/Tdsfeedbackslider';
import Tdslightbox from './components/Tdslightbox';
import Tdspricingtable from './components/Tdspricingtable';
import Tdsfooter from './components/Tdsfooter';
import './App.css';
import './responsive.css';
import KS from './services/KensoftApi';
import parse from 'html-react-parser';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Services: [],
      FProduct: [],
      IsoSection: [],
      OurProduct: [],
      name: '',
      email: '',
      message: '',
    };
  }

  componentDidMount() {
    KS.getServices({
      id: 20035,
      langid: 1,
    }).then((data) => {
      if (data.Success) {
        this.setState({ Services: data.Services });
      }
    });
    KS.getFProduct({
      id: 10037,
      langid: 1,
    }).then((data) => {
      if (data.Success) {
        this.setState({ FProduct: data.FProduct });
      }
    });
    KS.getIso({
      id: 20038,
      langid: 1,
    }).then((data) => {
      //console.log("isodata", data);
      if (data.Success) {
        this.setState({ IsoSection: data.Iso });
      }
      KS.getOurProduct({
        id: 132,
        langid: 1,
      }).then((data) => {
        //console.log("isodata", data);
        if (data.Success) {
          this.setState({ OurProduct: data.OurProduct });
        }
      });
    });
  }

  SendEmail = () => {
    KS.EmailForm({
      Name: this.state.name,
      Message: this.state.message,
      Email: this.state.email,
    }).then((data) => {
      if (data.Success) {
        this.setState({ name: '', message: '', email: '' });
        store.addNotification({
          title: 'Email was sent!',
          message: 'Thanks for contacting us',
          type: 'warning',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      } else {
        store.addNotification({
          title: 'Email was not sent!',
          message: 'Try Agian Later',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      }
    });
  };
  render() {
    return (
      <>
        <ReactNotification />
        <div className="App">
          {/* Navbar  */}
          <Tdsheader />

          {/* Hero Section Start */}
          <div id="home" className="section">
            <Tdsbanner />
          </div>
          {/* Subscribe Section Start*/}
          <div className=" subscribe-box grapping">
            {/* <Container>
                <Row className="align-items-center">
                <Col xs="12" md="12" lg="8" className="text-left"><h4 className="text-white"> Join the Soxolo! Sign up for the latest updates and news.</h4></Col>
                <Col xs="12" md="12" lg="4">
                    <Tdsinputgroup />
    
                </Col>
                </Row>
            </Container> */}
          </div>
          {/* Welcome Section Start */}
          <div className=" welcome-box grapping">
            <Container>
              <div className="title-box">
                <h2>
                  Welcome to <b>Al-Jawhara Co.</b>
                </h2>
                {/* <p>Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p> */}
              </div>
              <Row>
                <Col xs="12" sm="12" md="4">
                  <div className="white-bg wel-box coman-box">
                    <Icofont icon="icofont-home" />

                    <h4> Environmental friendly</h4>
                    <p>The factory operates as environmental friend.</p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="4">
                  <div className="white-bg wel-box coman-box">
                    <Icofont icon="icofont-safety" />
                    <h4>Safety standard criteria </h4>
                    <p>
                      The facility implements all safety standard requirements.
                    </p>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="4">
                  <div className="white-bg wel-box coman-box">
                    <Icofont icon="icofont-laboratory" />
                    <h4>Laboratories </h4>
                    <p>Have latest advanced technology.</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          {/* About us Section Start */}
          <div className="section about-box grapping" id="about">
            <Container>
              <Row>
                <Col xs="12" sm="12" md="12" lg="6">
                  <div className="about-img">
                    <img
                      src={require('./images/aboutus.jpg')}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="6">
                  <Tdsaboutslider />
                </Col>
              </Row>
            </Container>
          </div>
          {/* Our Services Section Start */}
          <div className="section ourservice grapping" id="services">
            <Container>
              <div className="title-box">
                <h2>
                  Our <b>Services</b>
                </h2>
                <p>There are many variations of passages of available.</p>
              </div>
              <Row>
                {(this.state.Services || []).map((item) => {
                  return (
                    <Col xs="12" sm="6" md="6" lg="3">
                      <div className="white-bg coman-box ourservice-box">
                        <i className={item.ShortDescription} />
                        <h4>{item.Name}</h4>
                        <p>{parse(item.Description)}</p>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </div>
          {/* Team Section Start */}
          <div className="section expert-team grapping" id="team">
            <Container>
              <div className="title-box">
                <h2>
                  Sales <b>Department</b>
                </h2>
                <p>
                  The department includes a large group of highly experienced
                  staff.
                </p>
              </div>
              <Row>
                <Col xs="12" sm="6" md="6" lg="3">
                  <div className="text-center coman-box team-box">
                    <div className="team-img">
                      <img
                        src={require('./images/team-img1.jpg')}
                        alt=""
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    {/*  <h4 className="text-white">Lucy Smith</h4>
                                    <p className="text-white">When an unknown printer took a galley of type and scrambled it to make a type specimen book</p>
                                    <ListGroup className="social-icon-team">
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-facebook" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-twitter" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-instagram" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-linkedin" /></ListGroupItem>

                                    </ListGroup>*/}
                  </div>
                </Col>
                <Col xs="12" sm="6" md="6" lg="3">
                  <div className="text-center coman-box team-box">
                    <div className="team-img">
                      <img
                        src={require('./images/team-img2.jpg')}
                        alt=""
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    {/*  <h4 className="text-white">Alex Maxwel</h4>
                                    <p className="text-white">When an unknown printer took a galley of type and scrambled it to make a type specimen book</p>
                                    <ListGroup className="social-icon-team">
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-facebook" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-twitter" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-instagram" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-linkedin" /></ListGroupItem>

                                    </ListGroup>*/}
                  </div>
                </Col>
                <Col xs="12" sm="6" md="6" lg="3">
                  <div className="text-center coman-box team-box">
                    <div className="team-img">
                      <img
                        src={require('./images/team-img3.jpg')}
                        alt=""
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    {/*  <h4 className="text-white">Steven Doe</h4>
                                    <p className="text-white">When an unknown printer took a galley of type and scrambled it to make a type specimen book</p>
                                    <ListGroup className="social-icon-team">
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-facebook" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-twitter" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-instagram" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-linkedin" /></ListGroupItem>

                                    </ListGroup>*/}
                  </div>
                </Col>
                <Col xs="12" sm="6" md="6" lg="3">
                  <div className="text-center coman-box team-box">
                    <div className="team-img">
                      <img
                        src={require('./images/team-img4.jpg')}
                        alt=""
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    {/* <h4 className="text-white"> Maxwel Doe </h4>
                                    <p className="text-white">When an unknown printer took a galley of type and scrambled it to make a type specimen book</p>
                                    <ListGroup className="social-icon-team">
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-facebook" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-twitter" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-instagram" /></ListGroupItem>
                                        <ListGroupItem tag="a" href="#">  <Icofont icon="icofont-linkedin" /></ListGroupItem>

                                    </ListGroup>
                                    */}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          {/* Portfolio Section Start*/}
          <div className="section ourportfolio grapping" id="portfolio">
            <Container>
              <div className="title-box">
                <h2>
                  Our <b>Products</b>
                </h2>
                <p> {this.state.OurProduct.Description}</p>
              </div>
              <Tdslightbox></Tdslightbox>
            </Container>
          </div>
          {/* Marketing Section Start*/}
          <div className="marketing-section grapping">
            <Container>
              <Row className="align-items-center">
                <Col xs="12" sm="12" md="12" lg="6">
                  <div className="marketing-img">
                    <img
                      src={require('./images/digitalmarketing.jpg')}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </Col>
                <Col xs="12" sm="12" md="12" lg="6">
                  {(this.state.IsoSection || []).map((item) => {
                    return (
                      <Media className="markrt-box">
                        <Media left href="#">
                          <Icofont icon={item.ShortDescription} />
                        </Media>
                        <Media body>
                          <Media heading>{item.Name}</Media>
                          {parse(item.Description)}
                        </Media>
                      </Media>
                    );
                  })}
                </Col>
              </Row>
            </Container>
          </div>
          {/* Expert Feadback Section Start */}
          {/*   <div className="expertfeesback grapping" >
                    <Container>
                        <div className="title-box">
                            <h2>Expert <b>Feadback</b></h2>
                            <p>Extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain</p>
                        </div>
                        <Tdsfeedbackslider></Tdsfeedbackslider>
                    </Container>
                </div>*/}
          {/* Our  Pricing Section Start*/}
          {/*  <div className="section ourlatest-pricing grapping" id="price">
            <Container>
                <div className="title-box">
                <h2>Our Latest  <b>Pricing</b></h2>
                <p>Dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                </div>
                <Tdspricingtable></Tdspricingtable>
            </Container>
            </div> /*}
            {/*Our Latest News  Section Start*/}
          <div className="section latestnews grapping" id="blog">
            <Container>
              <div className="title-box">
                <h2>
                  Product <b>Features</b>
                </h2>
                {/* <p>Dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>*/}
              </div>
              <Row>
                {this.state.FProduct.map((item) => {
                  return (
                    <Col xs="12" sm="12" md="4">
                      <Card>
                        <CardImg
                          top
                          width="100%"
                          src={item.FullImagePath + '.jpg'}
                          alt="Card image cap"
                        />
                        <Card body className="h-190">
                          <CardTitle>{parse(item.Name)}</CardTitle>
                          <CardText>{parse(item.Description)}</CardText>
                        </Card>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </div>
          {/* Work With Us  Section Start*/}
          <div className="workwithus grapping">
            <Container>
              <div className="title-box mb-0">
                <h2 className="text-white">
                  <b>Products Deserve trust</b>
                </h2>
                {/* <p className="text-white mb-4">Lets talk about project</p>*/}
              </div>
            </Container>
          </div>
          {/* Contact Us Section Start  */}
          <div className="section contactus grapping" id="contact">
            <Container>
              <div className="title-box">
                <h2>
                  Contact <b>Us</b>
                </h2>
                {/*    <p>Dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>*/}
              </div>
              <Row>
                <Col xs="12" md="12" lg="4">
                  <Media className="address-box">
                    <Media
                      left
                      href="https://www.google.com/maps/place/31%C2%B050'39.9%22N+36%C2%B000'52.0%22E/@31.8444118,36.0122576,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d31.8444118!4d36.0144463?hl=en"
                      target="_blank"
                    >
                      <Icofont icon="icofont-location-pin" />
                    </Media>
                    <Media body>
                      <Media heading>Address</Media>
                      <p>
                        {' '}
                        Amman-Jordan <br />
                        King AbdullahII Industrial City - Sahab
                      </p>
                    </Media>
                  </Media>
                </Col>
                <Col xs="12" md="6" lg="4">
                  <Media className="address-box">
                    <Media left href="#">
                      <Icofont icon="icofont-mail" />
                    </Media>
                    <Media body>
                      <Media heading>Email</Media>
                      <a href="mailto:info@al-jawhara.net">
                        {' '}
                        info@al-jawhara.net
                      </a>{' '}
                      <br />
                    </Media>
                  </Media>
                </Col>
                <Col xs="12" md="6" lg="4">
                  <Media className="address-box">
                    <Media left href="#">
                      <Icofont icon="icofont-phone" />
                    </Media>
                    <Media body>
                      <Media heading>Phone</Media>
                      <a href="tel:06-4020189"> 06-4020189</a> <br />
                    </Media>
                  </Media>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs="12" md="12" lg="4">
                  <h4>Get in Touch</h4>
                  <hr />
                  <p>
                    The company utilizes a fleet of vehicles for distribution
                    and follows safety standards in storage and transportation
                  </p>
                  <ListGroup className="social-icon">
                    <ListGroupItem tag="a" href="#">
                      {' '}
                      <Icofont icon="icofont-facebook" />
                    </ListGroupItem>
                    <ListGroupItem tag="a" href="#">
                      {' '}
                      <Icofont icon="icofont-twitter" />
                    </ListGroupItem>
                    <ListGroupItem tag="a" href="#">
                      {' '}
                      <Icofont icon="icofont-instagram" />
                    </ListGroupItem>
                    <ListGroupItem tag="a" href="#">
                      {' '}
                      <Icofont icon="icofont-linkedin" />
                    </ListGroupItem>
                    <ListGroupItem tag="a" href="#">
                      {' '}
                      <Icofont icon="icofont-youtube-play" />
                    </ListGroupItem>
                  </ListGroup>
                </Col>

                <Col xs="12" md="12" lg="8">
                  <Form className="mt-4">
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            type="text"
                            name="name"
                            id="examplename"
                            placeholder="Name"
                            onChange={(e) =>
                              this.setState({ name: e.target.value })
                            }
                            value={this.state.name}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Input
                            type="email"
                            name="email"
                            id="exampleEmail"
                            placeholder="Email"
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                            value={this.state.email}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <Input
                        type="textarea"
                        name="address"
                        id="exampleAddress"
                        placeholder="Your message"
                        onChange={(e) =>
                          this.setState({ message: e.target.value })
                        }
                        value={this.state.message}
                      />
                    </FormGroup>

                    <Button onClick={this.SendEmail} color="primary">
                      Send Message
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
          {/* Footer  Section Start */}
          <div className="">
            <Tdsfooter></Tdsfooter>
          </div>
        </div>
      </>
    );
  }
}

export default App;
